module.exports = __webpack_public_path__ + "static/media/CyclonX-RC-4380.17fdb16b.png";